module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeDropdown),
      expression: "closeDropdown"
    }],
    staticClass: "copy-calendars text-dark"
  }, [_c('button', {
    ref: "copy_calendars_button",
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openDropdown.apply(null, arguments)
      }
    }
  }, [_vm._t("copy-button-title", function() {
    return [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.copy')))]
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-arrow-down5 marg-5-left"
  })], 2), _vm._v(" "), (_vm.isDropdown) ? _c('div', {
    ref: "copy_calendars_panel",
    staticClass: "copy-calendars__ref"
  }, [_c('transition', {
    attrs: {
      "name": "fadeInDown"
    }
  }, [(_vm.isDropdownPopperDone) ? _c('div', {
    staticClass: "copy-calendars__panel"
  }, [_c('h3', {
    style: ({
      'backgroundColor': '#468ad7'
    })
  }, [(!_vm.copyDate) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendars.select_week_to_copy_from')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.calendars.select_weeks_that_week')) + " " + _vm._s(_vm.showWeek(_vm.copyDate)) + " " + _vm._s(_vm.$t('vue2.calendars.must_be_copied_to')))])]), _vm._v(" "), _c('div', {
    staticClass: "copy-calendars__panel__container"
  }, [_c('div', {
    staticClass: "weeks-container"
  }, [_c('ul', {
    staticClass: "weeks"
  }, [(_vm.weeks.length < 1) ? [_c('Spinner', {
    staticStyle: {
      "margin-bottom": "100px"
    },
    attrs: {
      "color": "blue"
    }
  })] : _vm._l((_vm.weeks), function(week) {
    return _c('li', {
      key: week.serverDate,
      staticClass: "weeks__week hint--top",
      class: [{
        'weeks__week--is-selected': _vm.isWeekSelected(week)
      }, {
        'weeks__week--is-copy-week': _vm.isCopyWeek(week)
      }],
      attrs: {
        "aria-label": _vm.tooltipDate(week.date)
      },
      on: {
        "click": function($event) {
          return _vm.setSelectedWeek(week)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.showWeek(week.date)) + "\n                  "), (_vm.isNow(week)) ? _c('span', {
      staticClass: "weeks__week__now-indicator"
    }) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "copy-calendars__panel__sidebar"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "out-in"
    }
  }, [(!_vm.copyDate) ? _c('div', {
    key: "1",
    staticClass: "text-explainer"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.calendars.select_week_to_copy_from')) + "\n              ")]) : _c('div', {
    key: "2"
  }, [_c('h4', [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.markWeeksFrom')) + " " + _vm._s(_vm.showWeek(_vm.copyDate)))]), _vm._v(" "), _c('button', {
    staticClass: "bttn width-100 btn-trans",
    on: {
      "click": _vm.addAllWeeksOnward
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.allWeeks')) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn width-100 btn-trans",
    on: {
      "click": _vm.selectOddWeeks
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.oddWeeks')) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn width-100 btn-trans",
    on: {
      "click": _vm.selectEvenWeeks
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.evenWeeks')) + "\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "bttn btn-trans width-100 btn-remove",
    on: {
      "click": _vm.removeAllSelectedWeeks
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.copycalendar.unselectAll')) + "\n                ")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "copy-calendars__panel__footer"
  }, [_c('div', {
    staticClass: "delete-option"
  }, [_c('label', {
    attrs: {
      "for": "checkbox"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.deleteLessonsInSelectedWeeks')))]), _vm._v(" "), (_vm.calType === 'user') ? _c('span', [_vm._v(" (" + _vm._s(_vm.$t('vue2.copycalendar.absenceWillNotBeDeleted')) + ")")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isDeleteEvents),
      expression: "isDeleteEvents"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isDeleteEvents) ? _vm._i(_vm.isDeleteEvents, null) > -1 : (_vm.isDeleteEvents)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isDeleteEvents,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isDeleteEvents = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isDeleteEvents = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isDeleteEvents = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.selectedWeeks.length < 1) ? _c('button', {
    staticClass: "bttn bttn--disabled"
  }, [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')) + "\n          ")]) : _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.copycalendar.paste')))])])]) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63dcf620!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CopyCalendar/CopyMultipleCalendarsCopy.vue
// module id = 1633
// module chunks = 1